import { render, staticRenderFns } from "./ProductionOrderStepEmbeddable.vue?vue&type=template&id=38bad76a&"
import script from "./ProductionOrderStepEmbeddable.vue?vue&type=script&lang=js&"
export * from "./ProductionOrderStepEmbeddable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports